export default "__VITE_ASSET__BqOOyenv__"